import { defineComponent, onMounted } from 'vue';
import QuickGuidePreviewComponent from '@/presentation/components/client/quick-guide-preview/quick-guide-preview-class';

export default defineComponent({
	setup: () => {
		const component = new QuickGuidePreviewComponent();

		onMounted(component.prepareQuickGuide.bind(component));

		return {
			previewUrl: component.previewUrl,
			previewHeight: component.previewHeight,
			previewWidth: component.previewWidth
		};
	}
});
